import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { toast } from "sonner"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Initials from a display name ("Ada Lovelace" → "AL"), "U" when absent. */
export function getUserInitials(name: string | null | undefined): string {
  if (!name) return "U";
  const parts = name.trim().split(" ");
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

/** First word of a display name, "User" when absent. */
export function getFirstName(name: string | null | undefined): string {
  if (!name) return "User";
  return name.trim().split(" ")[0];
}

/** The list with `value` toggled in or out — multi-select checkbox semantics. */
export function toggleValue(list: string[], value: string): string[] {
  return list.includes(value) ? list.filter((item) => item !== value) : [...list, value];
}

/**
 * Copy text to clipboard and show a toast notification
 * @param text - The text to copy to clipboard
 * @param label - Optional label for the toast message (e.g., "Email", "ID")
 * @returns Promise that resolves to true if successful, false otherwise
 */
export async function copyToClipboard(text: string, label?: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    const message = label ? `${label} copied to clipboard` : "Copied to clipboard";
    toast.success(message);
    return true;
  } catch (error) {
    console.error("Failed to copy to clipboard:", error);
    toast.error("Failed to copy to clipboard");
    return false;
  }
}
